import React from 'react';

type Props = {
	description?: string;
};

export default function DescriptionView(props: Props) {
	const { description } = props;

	if (!description) {
		return null;
	}

	return (
		<span data-test-id="project-directories.components.table.cell.description">{description}</span>
	);
}
